import { render } from "./App.vue?vue&type=template&id=15a03fc9&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=15a03fc9&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/协会网站/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__